
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"34","viewBox":"0 0 34 34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M31 34H3c-1.6 0-3-1.3-3-3V3c0-1.6 1.4-3 3-3h28c1.7 0 3 1.4 3 3v28c0 1.7-1.3 3-3 3z","fill":"url(#paint0_linear)"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.7 7.3v7.4h7.8V7.3h4.2v19.2h-4.2v-8.3H9.7v8.3H5.5V7.3h4.2zm23.4 5c-.7-.1-1.4-.1-2.1-.1-.8 0-1.5.1-2.3.2-.8.2-1.4.4-2.1.8-.6.3-1.1.8-1.5 1.4-.4.6-.6 1.4-.7 2.2h3.9c.1-.8.3-1.3.8-1.6.4-.3 1-.5 1.8-.5.3 0 .6 0 .9.1.3 0 .6.1.8.3.2.1.4.3.5.6.1.3.2.6.2 1s-.1.7-.3.9c-.3.2-.6.4-1 .5-.4.1-.9.2-1.5.3-.6 0-1.1.1-1.7.2-.6.1-1.1.2-1.7.4-.6.2-1.1.4-1.5.7-.4.3-.8.7-1.1 1.2-.3.5-.4 1.2-.4 2 0 .7.1 1.3.4 1.9.3.5.6.9 1 1.3.4.3.9.6 1.5.8.6.2 1.2.3 1.9.3.8 0 1.7-.1 2.5-.4.8-.3 1.5-.7 2.2-1.3v1c0 .1 0 .2.1.4h.3v-14c-.3-.5-.6-.5-.9-.6zm.1 8.9c0 .2 0 .5-.1.9 0 .3-.2.7-.4 1.1-.2.3-.5.6-.9.9-.4.3-1 .4-1.7.4-.3 0-.6 0-.9-.1-.3 0-.6-.1-.8-.3-.2-.1-.4-.3-.5-.6-.1-.3-.2-.5-.2-.9s.1-.7.2-.9c.1-.2.3-.4.5-.6.2-.2.5-.3.7-.4.3-.1.6-.2.8-.2.1 0 .3 0 .5-.1.2 0 .3 0 .5-.1.3 0 .6-.1.9-.1.1 0 .2 0 .2-.1.2 0 .4-.1.6-.2.3-.1.5-.2.6-.3v1.6z","fill":"#fff"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear","x1":"2.368","y1":"-2.902","x2":"31.929","y2":"37.306","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#0063A5"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#008DC7"}})])])])
          )
        }
      }
    